import { AuthService } from "@app/services/auth.service";

export interface IBaseScope extends ng.IScope {

}

export class BaseController {
    /**
     * a callback used by ui-router to notify us when query string parameters have been changed.
     * @param changedParams
     * @param $transition$
     */
    public uiOnParamsChanged(changedParams, $transition$) {
        // do something with the changed params
        // you can inspect $transition$ to see the what triggered the dynamic params change.
    }
}
